import { client } from '../../../shared/services/apiClient';

export const forgot = async (data: { email: string }): Promise<any> => {
  return client(false, false).post<{ email: string }>('/auth/forgot', data);
};
